/* global G */
import { pipe } from 'lib/util'
import { modelComposition } from 'trait/composition'
import { usesGetterSetter } from 'trait/uses'
import toRef from 'model/_shared/transformer/toRef'
import toObject from 'model/_shared/transformer/toObject'
import { withGetterSetter } from 'trait/with'
import fromObject from 'model/_shared/decorator/fromObject'
import dynamicData from 'model/_shared/validator/dynamicData'

const descriptor = 'model::typeExtension'

export default pipe(
  modelComposition(descriptor),
  withGetterSetter(G.VALIDATOR),
  usesGetterSetter(G.VALIDATOR, {
    dynamicData,
  }),
  usesGetterSetter(G.TRANSFORMER, {
    label: toObject('label', false),
    dynamicDataConfiguration: toObject('dynamicDataConfiguration', true),
    submitter: toRef('submitter'),
  }),
  withGetterSetter(G.DECORATOR),
  usesGetterSetter(G.DECORATOR, {
    label: fromObject('label'),
    dynamicDataConfiguration: fromObject('dynamicDataConfiguration'),
  }),
)
